import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {CardWebListElement} from './CardWebListElement';
import {DesignPostElement} from './design-post-element';
import {AuthService} from './auth.service';
import {switchMap} from 'rxjs/operators';
import {DesignGroupPostElement} from './design-group-post-element';
import {CommunityConnectorService} from './community-connector.service';

@Injectable({
  providedIn: 'root'
})
export class CardWebRestService {

  private readonly DESIGN_BASE_URL = '/sdesign';
  private readonly GROUP_BASE_URL = '/sgroup';

  private readonly DUMMY_DESIGN_NAME = 'KARTENTISCH';

  private designsChangeEvent: BehaviorSubject<CardWebListElement[]> = new BehaviorSubject<CardWebListElement[]>([]);

  constructor(private http: HttpClient, private authService: AuthService, private ccs: CommunityConnectorService) {
   this.emitDesignInvitationChangeEvent();
  }

  public getDesignsChangeListener() {
    return this.designsChangeEvent.asObservable();
  }

  public emitDesignInvitationChangeEvent(){
    this.authService.getUserId$().pipe(
      switchMap(userid => {
        const params = new HttpParams().set('userid', userid);
        return this.http.get<CardWebListElement[]>(`${this.DESIGN_BASE_URL}/getAll`, {params});
      })).subscribe(result => {
      this.designsChangeEvent.next(result);
    });
  }

  public getDummyDesignName() {
    return this.DUMMY_DESIGN_NAME;
  }

  public createDesign(design: DesignPostElement): Observable<CardWebListElement> {
    design.name = encodeURIComponent(design.name);
    return this.authService.getUserId$().pipe(
      switchMap(userid => {
        const params = new HttpParams().set('userid', userid);
        return this.http.post<CardWebListElement>(this.DESIGN_BASE_URL, design, {params});
      })
    );
  }

  public updateDesign(designName: string, design: DesignPostElement): Observable<CardWebListElement> {
    design.name = encodeURIComponent(design.name);
    return this.authService.getUserId$().pipe(
      switchMap(userid => {
        const params = new HttpParams()
          .set('userid', userid)
          .set('designName', designName);
        return this.http.put<CardWebListElement>(this.DESIGN_BASE_URL, design, {params});
      })
    );
  }

  public updateDesignGroup(designGroup: DesignGroupPostElement): Observable<DesignGroupPostElement> {
    return this.authService.getUserId$().pipe(
      switchMap(userid => {
        const params = new HttpParams()
          .set('userid', userid);
        return this.http.put<DesignGroupPostElement>(this.GROUP_BASE_URL, designGroup, {params});
      })
    );
  }

  public deleteDesign(designName: string, groupId: number): Observable<void> {
    return this.authService.getUserId$().pipe(
      switchMap(userid => {
        const params = new HttpParams()
          .set('userid', userid)
          .set('designName', designName)
          .set('groupId', groupId);
        return this.http.delete<void>(this.DESIGN_BASE_URL, {params});
      })
    );
  }

  public copyDesign(designName: string, designOwnerUserId: string): Observable<CardWebListElement> {
      return this.authService.getUserId$().pipe(
      switchMap(userid => {
          if (designOwnerUserId === null) {
              designOwnerUserId = userid;
          }
          const params = new HttpParams()
            .set('userid', userid)
            .set('designowneruserid', designOwnerUserId)
            .set('designName', designName);
          return this.http.get<CardWebListElement>(`${this.DESIGN_BASE_URL}/copy`, {params});
      })
    );
  }


  public createDesignGroup(designGroup: DesignGroupPostElement): Observable<DesignGroupPostElement> {
    return this.authService.getUserId$().pipe(
      switchMap(userid => {
        const params = new HttpParams().set('userid', userid);
        return this.http.post<DesignGroupPostElement>(this.GROUP_BASE_URL, designGroup, {params});
      })
    );
  }

  public getAllDesignGroups(): Observable<DesignGroupPostElement[]> {
    return this.authService.getUserId$().pipe(
      switchMap(userid => {
        const params = new HttpParams().set('userid', userid);
        return this.http.get<DesignGroupPostElement[]>(`${this.GROUP_BASE_URL}/getAll`, {params});
      })
    );
  }
    getDesignByDesignName(designName: string, designOwnerUserId: string) {
        return this.authService.getUserId$().pipe(
            switchMap(userid => {
              const params = new HttpParams()
                  .set('userid', designOwnerUserId)
                  .set('designName', designName);
              return this.http.get<CardWebListElement>(`${this.DESIGN_BASE_URL}/getDesign`, {params});
            })
        );
    }
}
